export default __webpack_public_path__ + "static/media/default_logo.fab67143.svg";